(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceDbhController', InstanceDbhController);

    InstanceDbhController.$inject = ['$state', 'Instance', 'ParseLinks', 'AlertService',
        'paginationConstants', 'pagingParams', '$interval', '$scope', 'Principal', 'Account', '$window', '$location',
        'InviteSendService', 'DbhawkUserService', 'Region', 'WizardHandler', 'Auth', '$uibModal', '$rootScope', '$http'];

    function InstanceDbhController($state, Instance, ParseLinks, AlertService, paginationConstants,
                                   pagingParams, $interval, $scope, Principal, Account, $window,
                                   $location, InviteSendService, DbhawkUserService, Region, WizardHandler,
                                   Auth, $uibModal, $rootScope, $http) {

        var vm = this;


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.disabledConfig = false;
        vm.disabledKey = false;
        vm.verificationData = {};

        vm.instance = {};
        vm.region = {name:"us-east-1"};
        vm.instance.cidrBlock = "172.10.0.0/16";
        vm.instance.userIp = null;
        vm.instance.accessOnlyToUserIp = true;


        vm.job = {};
        vm.jobs = [
            {name: 'IT Executive (CIO, CTO, VP Engineering, etc.)', code: 'IT_EXECUTIVE'},
            {name: 'Business Executive (CEO, COO, CMO, etc.)', code: 'BUSINESS_EXECUTIVE'},
            {name: 'Architect', code: 'ARCHITECT'},
            {name: 'Business Development / Alliance Manager', code: 'BUSINESS_DEVELOPMENT'},
            {name: 'DBA', code: 'DBA'},
            {name: 'Director / Development Manager', code: 'DIRECTOR'},
            {name: 'Product / Project Manager', code: 'PM'},
            {name: 'Software Developer / Engineer', code: 'DEVELOPER'},
            {name: 'Business Analyst', code: 'BA'},
            {name: 'Data Scientist', code: 'DATA_SCIENTIST'},
            {name: 'Student', code: 'STUDENT'},
            {name: 'Other', code: 'OTHER'}
        ];

        vm.db = {};
        vm.multipledb = {};
        vm.multipledb.selectedDbs = [];
        vm.dbs = [
            {name: 'Oracle', code: 'ORACLE', ticked: false},
            {name: 'SQL Server', code: 'SQL_SERVER', ticked: false},
            {name: 'MySQL', code: 'MYSQL', ticked: false},
            {name: 'PostgreSQL', code: 'POSTGRESQL', ticked: false},
            {name: 'DB2', code: 'DB2', ticked: false},
            {name: 'Greenplum', code: 'GREENPLUM', ticked: false},
            {name: 'Netezza', code: 'NETEZZA', ticked: false},
            {name: 'Teradata', code: 'TERADATA', ticked: false},
            {name: 'SAP Hana', code: 'SAP_HANA', ticked: false},
            {name: 'AWS RDS', code: 'AWS_RDS', ticked: false},
            {name: 'Azure MS SQL', code: 'AZURE_MS_SQL', ticked: false},
            {name: 'Redshift', code: 'REDSHIFT', ticked: false},
            {name: 'MongoDB', code: 'MONGODB', ticked: false},
            {name: 'Hadoop Hive', code: 'HADOOP_HIVE', ticked: false},
            {name: 'Other', code: 'OTHER', ticked: false}
        ];

        Region.query(function(result) {
            vm.regions = result;
        });


        vm.confirmKey = function () {
            vm.invalidCodeActivationError = null;
            vm.expiredCodeActivationError = null;
            vm.verificationData.activationKey = vm.activationKey;
            vm.verificationData.job = vm.job.selected.code;
            vm.verificationData.selectedDbs = [];
            if (vm.multipledb.selectedDbs) {
                vm.verificationData.selectedDbs = vm.multipledb.selectedDbs.map(function(a) {return a.code;}) ;
            }


            Auth.activateAccount(vm.verificationData).then(function () {
                vm.invalidCodeActivationError = null;
                vm.expiredCodeActivationError = null;
                vm.success = 'OK';
                vm.disabledKey = true;
                $rootScope.activated = true;
                WizardHandler.wizard().next();
                setTimeout(function () {
                    nextStep();
                }, 100);

            }).catch(function (err) {
                vm.success = null;
                if (err.data && err.data.detail &&  err.data.detail === 'ActivationKey.Expired') {
                    vm.expiredCodeActivationError = 'ERROR';
                } else {
                    vm.invalidCodeActivationError = 'ERROR';
                }
            });


        };


        vm.confirmKeyDemo = function () {
            vm.invalidCodeActivationError = null;
            vm.expiredCodeActivationError = null;
            vm.verificationData.activationKey = vm.activationKey;
			vm.verificationData.job = '';//vm.job.selected.code;
            vm.verificationData.selectedDbs = [];
            /*if (vm.multipledb.selectedDbs) {
                vm.verificationData.selectedDbs = vm.multipledb.selectedDbs.map(function(a) {return a.code;}) ;
            }*/

            Auth.activateAccount(vm.verificationData).then(function () {
                vm.invalidCodeActivationError = null;
                vm.expiredCodeActivationError = null;
                vm.success = 'OK';
                vm.disabledKey = true;
                $rootScope.activated = true;

                setTimeout(function () {
                    createDemoInstance();
                }, 100);

            }).catch(function (err) {
                vm.success = null;
                if (err.data && err.data.detail &&  err.data.detail === 'ActivationKey.Expired') {
                    vm.expiredCodeActivationError = 'ERROR';
                } else {
                    vm.invalidCodeActivationError = 'ERROR';
                }
            });


        };

        function createDemoInstance(){
            vm.instance.demoInstance = true;
            Instance.save(vm.instance, onSaveSuccessDemo, onSaveError);
        }





        $http.get("https://api.ipify.org/?format=json").then(function (response) {
            vm.instance.userIp = response.data.ip;
        });

        vm.save = function save () {
            vm.isSaving = true;
            vm.instance.region = vm.region.name;
            Instance.save(vm.instance, onSaveSuccess, onSaveError);
        };

        vm.finishedWizard = function finishedWizard() {
            $state.go('instances');
        };

        function onSaveSuccessDemo (result) {
            vm.isSaving = false;

            vm.disabledConfig = true;
            $state.go('instances');

        }


        function onSaveSuccess (result) {
            vm.isSaving = false;

            vm.disabledConfig = true;
            WizardHandler.wizard().next();

            setTimeout(function () {
                nextStep();
            }, 100);


            vm.promise = $interval($scope.getInstances, 50*1000);


            $scope.timer = 5;
            $scope.max = 77;

            var countDown = $interval(function () {
                $scope.timer++;
                if ($scope.timer === 35) {
                    nextStep();
                    WizardHandler.wizard().next();
                    //$interval.cancel(countDown);
                }
            }, 5000);

            $scope.$on('$destroy',function(){
                if(vm.promise){
                    $interval.cancel(vm.promise);
                    $interval.cancel(countDown);
                }
            });

        }

        function onSaveError () {
            vm.isSaving = false;
            vm.errorLaunch ='ERROR';
            AlertService.error("Error Launch Instance. Please, contact support");
        }

        Account.get().$promise.then(getAccountThen);

        function getAccountThen (account) {
            vm.account = account.data;

            if(vm.account.activated ==true){
                Instance.query({
                    page: 0,
                    size: 10
                }, onSuccess1, onError1);
            }

        }





        function onSuccess1(data, headers) {

            var totalItems = headers('X-Total-Count');


            if(   totalItems<2){
                vm.disabledKey = true;
               // WizardHandler.wizard().next();
            }
            else{
                WizardHandler.wizard().next();
                $state.go('instances');
            }


        }
        function onError1(error) {
            $state.go('instances');
        }



        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }


        vm.loadingMessage = "Creating a brand new DBHawk cloud application for you";

        vm.quotes = [
            {
                value: "Creating an AWS EC2 machine, creating your  VPC, and provisioning your DBHawk domain name..."
            },
            {
                value: "It will take around 6 to 8 minutes to install and configure everything."
            },
            {
                value: "Now deploying DBHawk web application."
            },
			{
                value: "Installing SSL Certificate."
            },
            {
                value: "We are almost there... "
            },
            {
                value: "Once the deployment is complete, you can launch and access DBHawk."
            },
            {
                value: "You can invite more users, click on Invite more users button after DBHawk installation."
            },
            {
                value: "Still installing and deploying... "
            }

        ];


        vm.i=0;

        $scope.getInstances = function () {
             loadAll();

            vm.loadingMessage = vm.quotes[vm.i].value;

            if(vm.i<6){
                vm.i = vm.i+1;
            }
        };

        function loadAll () {



            Instance.query({
                page: 0,
                size: 10,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instances = data;

                angular.forEach(vm.instances, function(value, key) {
                    if(value.instance.status === 'running ok' && value.instance.dbhawkUrl!=null){

                        $scope.timer = $scope.max;

                        DbhawkUserService.getUsersForInstance(value.instance.instanceId).then(function(response) {

                        }).catch(function(response) {

                        });

                        setTimeout(function(){
                            WizardHandler.wizard().next();
                            $interval.cancel(vm.promise);
                         }, 1 * 10 * 1000 );





                    }
                });
                vm.page = pagingParams.page;

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function nextStep() {
            var next_step = true;
            if ($('.steps-indicator li:first').hasClass('current')) {
                next_step = false;
            }

            if (next_step) {

                var current_active_step = $('.f1-steps').find('.f1-step.active');
                var progress_line = $('.f1-steps').find('.f1-progress-line');

                current_active_step.removeClass('active').addClass('activated').next().addClass('active');
                // progress bar
                bar_progress(progress_line, 'right');
            }
        }
    }
})();
